module.exports = __webpack_public_path__ + "responsive._fuoSHS0.svg";